import { useMemo } from 'react'
import { calcMatchPlay } from './ggMatchPlay.js'
import { samplePlayers } from './ggSamplePlayers.js'

// G-MatchPlay — isolated sandbox. 1v1 holes-up; uses the first two sample
// players. calcMatchPlay ported from GolfGamesScorecard.
const cell = { border: '1px solid #ddd', padding: '6px 10px', fontSize: 16 }

export default function GMatchPlay() {
  const [p1, p2] = useMemo(() => samplePlayers().slice(0, 2), [])
  const r = useMemo(() => calcMatchPlay(p1, p2), [p1, p2])
  const won = (side) => r.results.filter((x) => x === side).length

  return (
    <div className="card">
      <p className="text-sm mb-3"><b>{p1.name}</b> vs <b>{p2.name}</b> — leader: <b>{r.leader}</b>{r.p1Up !== 0 ? ` (${Math.abs(r.p1Up)} up)` : ' (all square)'}</p>
      <table className="w-full text-base" style={{ borderCollapse: 'collapse' }}>
        <thead><tr style={{ background: '#f6f6f2', color: '#555' }}>{['Player', 'Holes won'].map((h) => <th key={h} style={{ ...cell, textAlign: 'left' }}>{h}</th>)}</tr></thead>
        <tbody>
          <tr><td style={cell}>{p1.name}</td><td style={cell}><b>{won('p1')}</b></td></tr>
          <tr><td style={cell}>{p2.name}</td><td style={cell}><b>{won('p2')}</b></td></tr>
          <tr><td style={cell}>Halved</td><td style={cell}>{won('halved')}</td></tr>
        </tbody>
      </table>
    </div>
  )
}
